import { FC, PropsWithChildren } from "react";

import { useLiveMapCtxProvider } from "./hooks";
import { LiveMapContext } from "./live-map.context";

export const LiveMapContextWrapper: FC<PropsWithChildren> = ({ children }) => {
  const contextValue = useLiveMapCtxProvider();
  return (
    <LiveMapContext.Provider value={contextValue}>
      {children}
    </LiveMapContext.Provider>
  );
};
